import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function LinkedInIcon({
	width,
	height,
	active = false,
	customIconColor,
	'aria-label': ariaLabel = 'LinkedIn',
	style,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>LinkedIn</title>
			<path
				d="M30.5348 0H9.46517C4.2377 0 0 4.2377 0 9.46517V30.5348C0 35.7623 4.2377 40 9.46517 40H30.5348C35.7623 40 40 35.7623 40 30.5348V9.46517C40 4.2377 35.7623 0 30.5348 0Z"
				fill={bg}
			/>
			<path
				d="M8.63105 12.1227C10.5798 12.1227 12.1596 10.5429 12.1596 8.59418C12.1596 6.64544 10.5798 5.06567 8.63105 5.06567C6.68231 5.06567 5.10254 6.64544 5.10254 8.59418C5.10254 10.5429 6.68231 12.1227 8.63105 12.1227Z"
				fill={g}
			/>
			<path d="M11.8074 14.594H5.66699V34.284H11.8074V14.594Z" fill={g} />
			<path
				d="M34.2974 21.5941V34.2864H28.1579V22.6848C28.1579 21.8295 27.8403 20.9962 27.2404 20.3877C26.7553 19.8959 26.0942 19.54 25.1939 19.4893C23.6564 19.4022 22.669 20.3111 22.0538 21.3119C21.6864 21.9089 21.5008 22.6016 21.5008 23.3029V34.2874H15.3613V14.5974H21.5008V16.7242C23.1589 14.9743 25.744 14.0233 28.1005 14.2166C28.6975 14.2654 29.2859 14.3926 29.8437 14.5974C30.6838 14.9035 31.4539 15.3857 32.0825 16.0421C33.0288 17.0294 33.6535 18.2924 34.018 19.6012C34.0401 19.6806 34.0621 19.761 34.0821 19.8404C34.2295 20.4135 34.2984 21.0038 34.2984 21.5951L34.2974 21.5941Z"
				fill={g}
			/>
		</svg>
	);
}
